import Box from "@mui/material/Box";
import React from "react";
import {Typography} from "@mui/material";
import ScatterChart from "../../../../components/charts/Scatter";
import heatMapData from "../../test/heatmap.json";

export default function HeatmapExport({heatmapData}) {
    return (
        <Box sx={{ bgcolor: "#f9f9f9"}}>
            <Box
                key={1}
                id={`tlm-threat-1`} // Unique ID for each threat
                sx={{
                    padding: 4,
                    width: "210mm", // A4 width
                    height: "210mm", // A4 height
                    margin: "auto", // Center the box horizontally
                    marginBottom: "20px",
                    pageBreakAfter: "always", // Ensure each box starts on a new page in the PDF
                    boxShadow: 3,
                    borderRadius: 2,
                    bgcolor: "#f9f9f9",
                    boxSizing: "border-box", // Include padding in the total width/height
                    overflow: "hidden", // Prevent content from overflowing
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                {/* Threat Title */}
                <Typography
                    sx={{
                        textAlign: "center",
                        fontSize: {xs: "32px", sm: "40px"}, // Increased font size
                        fontWeight: "bold",
                        marginBottom: "20px", // Increased spacing
                    }}
                >
                    Heatmap
                </Typography>

                {/* Heatmap Container */}
                <Box
                    sx={{
                        width: "100%", // Take full width of the parent container
                        height: "80%", // Allocate 80% of the height for the chart
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        boxShadow: 3,
                        borderRadius: 2,
                        padding: 2,
                        bgcolor: "background.paper",
                        overflow: "hidden", // Ensure the chart doesn't overflow
                    }}
                >
                    <ScatterChart
                        data={heatMapData}
                        xLabel="x"
                        yLabel="y"
                        style={{
                            width: "100%", // Ensure the chart takes up the full width
                            height: "100%", // Ensure the chart takes up the full height
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
}